/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSelect.vue?vue&type=template&id=5f6e3858&scoped=true"
import script from "./ForumSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSelect.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSelect.vue?vue&type=style&index=0&id=5f6e3858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e3858",
  null
  
)

export default component.exports